export enum resultValues {
  success = "SUCCESS",
  failure = "FAILURE",
}